module.exports = __webpack_public_path__ + "img/anggota_in.a1f01a3b.png";